import { Nullable } from 'utils/types';

export type FirmsResponseData = {
  admins: Array<any>;
  city: string;
  club: any;
  commission_term: { id: number; name: string; commission_terms: string; commission_for: string };
  county: string;
  directly_authorised_context: any;
  email: string;
  fca: { id: number; number: string; is_active: boolean };
  has_firm_directors_consent: boolean;
  house_number: string;
  id: number;
  is_active: boolean;
  is_fully_activated: boolean;
  is_data_protection_policy_confirmed: Nullable<boolean>;
  is_introducer_agreement_confirmed: Nullable<boolean>;
  is_privacy_policy_confirmed: Nullable<boolean>;
  name: string;
  network: string;
  phone: string;
  post_code: string;
  registered_at: string;
  street_line_1: string;
  street_line_2: Nullable<string>;
  dd_status: Nullable<string>;
};

export type Data = {
  id: string;
  firmName: string;
  firmEmail: string;
  fcaNumber: string;
  firmLocation: string;
  fcaStatus: boolean;
  lmcStatus: boolean;
  fcaId: number;
  registeredAt: string;
  ddStatus: Nullable<string>;
};

export enum FILTER_NAMES {
  ALL = 'all',
  APPROVED = 'approved',
  DECLINED = 'declined',
  AWAITING_ASSESSMENT = 'awaiting-assessment',
}

export enum FILTER_LABELS {
  ALL = 'Show all DD status',
  APPROVED = 'Approved',
  DECLINED = 'Declined',
  AWAITING_ASSESSMENT = 'Awaiting assessment',
}

export enum QUERY_PARAMS {
  PAGE = 'page',
  FILTER = 'filter',
  SEARCH = 'search',
}
